<div class="progressbar" (click)="setPosition($event)">
  <div class="inner" [ngStyle]="{'width.px': innerWidth}"></div>
</div>
